import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Redirect old /operations/communications URLs to /operations/exotel-calling */
const LegacyCommunicationsRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();
  const next = pathname.replace(/^\/operations\/communications/, '/operations/exotel-calling');
  return <Navigate to={`${next}${search}${hash}`} replace />;
};

export default LegacyCommunicationsRedirect;
